import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Permissions} from "../../../../../user/permissions";
import {Product} from "../../../product";
import {Website} from "../../../website";
import {ActivatedRoute} from '@angular/router';
import {UserSubscription} from "../../../../../user/user-subscription";
import * as fromStore from "../../../../../store";
import {Store} from "@ngrx/store";
import {ActivityAction, ActivityStatus, IActivity} from "../../../../../activities/activity";
import {DbStoreState} from "../../../../../store/reducers";
import {map, Observable} from "rxjs";

@Component({
    selector: 'db-widget-product-item',
    templateUrl: './widget-product-item.component.html',
    styleUrls: ['./widget-product-item.component.scss'],
    standalone: false
})
export class WidgetProductItemComponent implements OnInit {

  public ActivityAction = ActivityAction;
  public ActivityStatus = ActivityStatus;

  @Input() website: Website;
  @Input() product: Product;
  @Input() selectAll: boolean;
  @Input() productsLoading: boolean;
  @Input() userPermissions: Permissions;
  @Input() status: string;

  @ViewChild('logo') logoRef: ElementRef;

  @Output() toggled: EventEmitter<void> = new EventEmitter<void>();
  @Output() updateItem: EventEmitter<Product> = new EventEmitter<Product>();

  public isManagable: boolean;

  private _userSubscriptions: UserSubscription[];
  public currentSubscription: UserSubscription;

  public ongoingActivity$: Observable<IActivity>;
  public ongoingActivityStatusClass$: Observable<string>;
  @Input() loading = false;

  constructor(
    private _store: Store<DbStoreState>,
    private _route: ActivatedRoute
  ) {
    this.toggled = new EventEmitter<void>();
  }


  ngOnInit() {
    this.isManagable = this.website && !this.website.isLocalhost && this.userPermissions?.canManageContent;

    this._userSubscriptions = this._route.snapshot.parent.data['subscriptions'];
    this.currentSubscription = this._route.snapshot.parent.data['subscription'];

    this.ongoingActivity$ = this._store.select(fromStore.getProductOngoingActivity(this.website.id, this.product.slug));
    this.ongoingActivityStatusClass$ = this.ongoingActivity$.pipe(map((activity: IActivity): string => {
      if (!activity) {
        return '';
      }

      if (activity.status === ActivityStatus.DONE) {
        return 'success';
      }
      if (activity.status === ActivityStatus.FAILED) {
        return 'danger';
      }

      return 'info';
    }));
  }

  public update(): void {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.product],
      action: ActivityAction.UPDATE,
      network: 1
    }));
  }

  public onProductToggled(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.product.selected = target.checked;
    this.toggled.emit();
  }

  public onItemToggled(): void {
    this.toggled.emit();
  }

  public stopEvent($event): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
